import type { FC } from 'react';
import { useStore } from 'zustand';

import { type IconComponentFunction, Button } from '@motorway/mw-highway-code';

import { ModalBackButton } from 'Features/SellerCommunications/components/ModalBackButton';
import { ModalBody } from 'Features/SellerCommunications/components/ModalBody';
import { ModalFooter } from 'Features/SellerCommunications/components/ModalFooter';
import { ModalHeader } from 'Features/SellerCommunications/components/ModalHeader';
import {
	EmailBodyStore,
	emailEditorService,
	EnquiriesSelectStore,
	processingEmailService,
} from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import { ReactComponent as SendEmailIcon } from 'Public/static/images/send-email-icon-fill.svg';
import { triggerSellerMessagingBackButtonClickedEvent } from 'Services/analytics/events';
import { ModalStepsToStageMap } from 'Services/analytics/events/account/purchases/consts';

import { EmailForm } from './EmailForm';

export const EmailEditor: FC = () => {
	const { selectedSaleIds } = useStore(EnquiriesSelectStore);
	const selectedSalesCount = selectedSaleIds.length;
	const bodyError = useStore(EmailBodyStore, (state) => state.bodyError);
	const isBodyEmpty = useStore(EmailBodyStore, (state) => state.isBodyEmpty);

	const isButtonDisabled = bodyError ?? isBodyEmpty;

	const onBackButtonClick = () => {
		emailEditorService.onBackButtonCLick();
		triggerSellerMessagingBackButtonClickedEvent({
			from: ModalStepsToStageMap.EmailEditor,
			to: ModalStepsToStageMap.EnquirySelection,
		});
	};

	return (
		<>
			<ModalBackButton onClick={onBackButtonClick} />
			<ModalHeader description={T.translate('createEmail.description')} title={T.translate('createEmail.title')} />
			<ModalBody>
				<EmailForm />
			</ModalBody>
			<ModalFooter>
				<Button
					data-thc-button-footer
					disabled={!!isButtonDisabled}
					icon={SendEmailIcon as IconComponentFunction}
					label={T.translate('createEmail.sendMessage', { count: selectedSalesCount })}
					onClick={processingEmailService.onEmailSend}
				/>
			</ModalFooter>
		</>
	);
};
